import * as React from 'react';
import { AppComponentProps } from '../../typescriptHelpers';
import { antGrey, runwayColors } from '../styles/globalStyles';
import {
    createAppSettingsAutomationsRouteWithAutomation,
    createAppSettingsRouteWithSettingType,
} from '../../helpers/routeHelpers';
import { SettingType } from '../../types';
import { useHistory } from 'react-router-dom';
import Button from 'antd/lib/button';
import { ThunderboltFilled, SettingOutlined } from '@ant-design/icons';
import { useSelector } from 'react-redux';
import { RootState } from '../../reducers/reducers';
import { selectAutomationById } from '../../selectors/selectors';

interface AutomationSettingsBannerProps extends AppComponentProps {
    bannerStyle?: React.CSSProperties;
    bannerText: React.ReactNode;
    automationId: string;
    isEnabled: boolean;
}

const AutomationSettingsBanner: React.FC<AutomationSettingsBannerProps> = (props: AutomationSettingsBannerProps) => {
    const history = useHistory();
    const automation = useSelector((state: RootState) => selectAutomationById(state, props.appId, props.automationId));
    const bannerColor = props.isEnabled ? runwayColors.primary : antGrey.grey6;
    const bannerStyle: React.CSSProperties = {
        ...{
            backgroundColor: `${bannerColor}10`,
            border: `1px solid ${bannerColor}50`,
            display: 'flex',
            flexDirection: 'row',
            flexGrow: 1,
            marginTop: 8,
            borderRadius: '5px',
            padding: 8,
            alignItems: 'flex-start',
        },
        ...props.bannerStyle,
    };

    const automationsRoute =
        automation?.id != null ?
            createAppSettingsAutomationsRouteWithAutomation(props.orgId, props.appId, automation.id)
        :   createAppSettingsRouteWithSettingType(props.orgId, props.appId, SettingType.Automations);

    return (
        <div style={bannerStyle}>
            <ThunderboltFilled style={{ marginLeft: 7, marginRight: 15, marginTop: 4, color: bannerColor }} />
            <div style={{ flex: 1, minWidth: 0 }}>{props.bannerText}</div>
            <Button
                type="link"
                style={{ color: runwayColors.primary, marginLeft: 'auto', height: 22, padding: 0 }}
                onClick={() => {
                    history.push(automationsRoute);
                }}
                icon={
                    <SettingOutlined
                        style={{
                            color: runwayColors.primary,
                        }}
                    />
                }
            ></Button>
        </div>
    );
};

export default AutomationSettingsBanner;
